// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/focus-filled.svg';

export const FocusFilled = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
